import { isPlatformBrowser } from "@angular/common";
import { APP_ID, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EngagementService } from "./shared/data-access-engagement/engagement.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Answer Online";
  private destroy$: Subject<any> = new Subject<any>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string,
    private activatedRoute: ActivatedRoute,
    private engagementService: EngagementService
  ) {}

  onActivate(event: any) {
    this.activatedRoute.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe((params) => {
      if (params["a"] == undefined && isPlatformBrowser(this.platformId)) {
        const scrollToTop = window.setInterval(() => {
          const pos = window.pageYOffset;
          if (pos > 0) {
            window.scrollTo(0, pos - 50); // how far to scroll on each step
          } else {
            window.clearInterval(scrollToTop);
          }
        });
      }
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.engagementService.init();
    }
  }

   ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
